var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-tab-pane", { attrs: { name: "subscription" } }, [
    _c("p", { staticClass: "q-mb-none" }, [
      _vm._v(_vm._s(_vm.$t("subscriptions_moved")))
    ]),
    _c("a", { staticClass: "primary-link", attrs: { href: _vm.betaLink } }, [
      _vm._v(_vm._s(_vm.$t("goto_new_version")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }